import React, { useEffect } from 'react';
import Menu from './components/Menu';
import { QueryClient, QueryClientProvider } from 'react-query';
import { combineReducers } from '@reduxjs/toolkit';
import { settingsReducer, actions } from './hooks/useSettings';
import { asiteRelaticsSecurityReducer, actionsSecurity } from './hooks/useSecurity/useSecurityStore';
import { ConfigPageComponent, ModePage } from '../../modules/core/types/common/ConfigPageComponent';
import { useDispatch } from 'react-redux';
import * as x from '../../modules/navigation/ducks/navbar';
const queryClient = new QueryClient();

const AsiteRelatics = (props: ConfigPageComponent) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.setAppLink(props.link));
        dispatch(actions.setModePage(ModePage.BaseComponent));
        dispatch(x.setShowNavBar(props?.showHeader ?? true));
        dispatch(actionsSecurity.loadSecurity("A_R_Sync"));
    }, [dispatch]);


    return (
        <QueryClientProvider client={queryClient}>
            <Menu />
        </QueryClientProvider>  
    );
};

export default AsiteRelatics;

export const asiteRelaticsSyncLogsReducer = combineReducers({
    settings: settingsReducer,
    security: asiteRelaticsSecurityReducer
});
